import type { ListBuilderConfiguration } from '../types';

/**
 * Client Visits list configuration
 * Converted from JSON to TypeScript for type safety
 */
export const CLIENT_VISITS_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-client-visits',
			cacheTTL: 600000,
			name: 'Client Visits',
			type: 'default',
			active: true,
			columns: [
				{
					id: 'visit-date',
					headers: [
						{
							id: 'visit-date-header',
							text: 'Visit Date',
						},
					],
					fields: [
						{
							id: 'visit-date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'visitDate',
									objectTable: 'client_visit',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
								formatOptions: {
									dateFormat: 'datetime-medium',
								},
							},
							displayStyle: 'date',
						},
					],
					sortable: true,
					width: 200,
				},
				{
					id: 'visitor',
					headers: [
						{
							id: 'visitor-header',
							text: 'Logged By',
						},
					],
					fields: [
						{
							id: 'visitor-name',
							dataConfig: {
								type: 'template',
								template: '{firstName} {lastName}',
								templateFields: [],
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'muted',
								},
							},
							displayStyle: 'text',
						},
					],
					sortable: false,
				},
				{
					id: 'created-date',
					headers: [
						{
							id: 'created-date-header',
							text: 'Created',
						},
					],
					fields: [
						{
							id: 'created-date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: '_created_date',
									objectTable: 'client_visit',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'muted',
								},
								formatOptions: {
									dateFormat: 'datetime-medium',
								},
							},
							displayStyle: 'date',
						},
					],
					sortable: true,
					width: 200,
				},
				{
					id: 'actions',
					headers: [
						{
							id: 'actions-header',
							text: '',
						},
					],
					fields: [
						{
							id: 'actions-dropdown',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'actions_dropdown',
							dropdownActions: [
								{
									id: 'delete-action',
									label: 'Delete',
									iconName: 'trash',
									callbackName: 'deleteClientVisit',
									variant: 'danger',
									visibility: 'visible',
									requiredPermission: 'clients:visits:delete',
								},
							],
						},
					],
					sortable: false,
					width: 60,
					align: 'center',
				},
			],
			defaultSortId: 'visit-date-desc',
			sortOrder: 0,
		},
	],
	paging: {
		defaultPageSize: 20,
		pageSizeOptions: [10, 20, 50, 100],
	},
	filters: {
		activeFilters: ['visitDateRange', 'visitUser'],
		defaultFilters: {},
	},
	objects: [
		{
			objectLabel: 'Client Visit',
			objectTable: 'client_visit',
			selectedFields: [
				{
					fieldName: '_id',
					fieldLabel: 'ID',
				},
				{
					fieldName: 'clientId',
					fieldLabel: 'Client ID',
				},
				{
					fieldName: 'visitDate',
					fieldLabel: 'Visit Date',
				},
				{
					fieldName: 'workdUserId',
					fieldLabel: 'User ID',
				},
				{
					fieldName: 'latitude',
					fieldLabel: 'Latitude',
				},
				{
					fieldName: 'longitude',
					fieldLabel: 'Longitude',
				},
				{
					fieldName: '_created_date',
					fieldLabel: 'Created Date',
				},
				{
					fieldName: '_creator_userId',
					fieldLabel: 'Creator User ID',
				},
			],
		},
		{
			objectLabel: 'User',
			objectTable: 'user',
			selectedFields: [
				{
					fieldName: 'firstName',
					fieldLabel: 'First Name',
				},
				{
					fieldName: 'lastName',
					fieldLabel: 'Last Name',
				},
				{
					fieldName: 'workdUserId',
					fieldLabel: 'Workd User ID',
				},
			],
		},
	],
	// PD-15683 — defaultSortId must reference a root-level TableSortOption
	// (name + fields); pointing it at a column id resolves no sort fields and
	// logs a ListBuilder warning on every load.
	tableSorts: [
		{
			id: 'visit-date-desc',
			name: 'Visit Date (Newest First)',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'visitDate',
					objectTable: 'client_visit',
				},
			],
		},
	],
};
